function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M82.975-871.412h.625v-3.475a1 1 0 0 0 .619-.331.929.929 0 0 0 .256-.644v-1.925a.269.269 0 0 0-.088-.206.3.3 0 0 0-.212-.081.28.28 0 0 0-.206.081.28.28 0 0 0-.081.206v1.5h-.275v-1.5a.28.28 0 0 0-.081-.206.28.28 0 0 0-.206-.081.28.28 0 0 0-.206.081.28.28 0 0 0-.081.206v1.5h-.362v-1.5a.28.28 0 0 0-.081-.206.28.28 0 0 0-.206-.081.28.28 0 0 0-.206.081.28.28 0 0 0-.081.206v1.925a.941.941 0 0 0 .25.644.985.985 0 0 0 .625.331zm3.162 0h.625v-3.325a1.35 1.35 0 0 0 .688-.625 2.127 2.127 0 0 0 .25-1.05 1.973 1.973 0 0 0-.344-1.187 1.035 1.035 0 0 0-.869-.475 1.019 1.019 0 0 0-.863.475 2 2 0 0 0-.338 1.188 2.331 2.331 0 0 0 .225 1.075 1.213 1.213 0 0 0 .625.6zM80.75-870a.72.72 0 0 1-.525-.225.72.72 0 0 1-.225-.525v-8.5a.72.72 0 0 1 .225-.525.72.72 0 0 1 .525-.225h8.5a.72.72 0 0 1 .525.225.72.72 0 0 1 .225.525v8.5a.72.72 0 0 1-.225.525.72.72 0 0 1-.525.225z",
    transform: "translate(-80 880)",
    style: {
      fill: "#196cca"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunch);
export default __webpack_public_path__ + "static/media/lunch.2394eb366ef1c9aa6193de089e6a447e.svg";
export { ForwardRef as ReactComponent };